import { frontendURL } from 'dashboard/helper/URLHelper';
import HomePage from 'vinctoHome/pages/HomePage.vue';

// Pagina Inicio / Painel geral. Entrada pos-login de quem tem o Painel (admin
// ou funcao com dashboard_overview); carregada EAGER porque e a landing.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/inicio'),
    name: 'vincto_home',
    meta: {
      permissions: ['administrator', 'agent', 'dashboard_overview'],
    },
    component: HomePage,
  },
];
